import { systemPrefersDark, useTheme } from '../app/theme';
import { useT } from '../i18n';
import { MoonIcon, SunIcon } from './Icons';

export function ThemeToggle() {
  const t = useT();
  const pref = useTheme((s) => s.pref);
  const toggle = useTheme((s) => s.toggle);
  const dark = pref === 'dark' || (pref === 'system' && systemPrefersDark());
  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={dark}
      title={`${t('theme.label')}: ${dark ? t('theme.dark') : t('theme.light')}`}
      className="inline-flex h-11 w-11 items-center justify-center text-txt transition-colors hover:text-fg"
    >
      <span className="sr-only">{`${t('theme.label')}: ${dark ? t('theme.dark') : t('theme.light')}`}</span>
      {dark ? <MoonIcon /> : <SunIcon />}
    </button>
  );
}
